import { useNavigate } from "react-router-dom";

export default function TabsControls({ controlOptions, setActiveTab, activeTab }) {
    const navigate = useNavigate();
    return (
        <ul className="cot-tabs-block">
            <div className="slider"></div>

            {controlOptions.map((item) => (
                <li
                    key={item.id}
                    className={`tab-item tag ${activeTab === item.id ? "--tab-active" : ""}`}
                    onClick={() => {
                        setActiveTab(item.id);
                        navigate(`/fondos/${item.fondoId}`);
                    }}
                >
                    {item.label}
                </li>
            ))}
        </ul>
    );
}
